<template>
    <div
        class="md-hero layout10 mg-bg"
        :class="[
            `banner-with-search-group`,
            isMobileSize ? `mobile` : ``,
            type
        ]"
        :style="{ ...spaceStyle, ...colorStyle, backgroundColor, minHeight: isMobileSize ? mobileHeight : 'auto' }"
    >
        <!-- layout10 deprecated in maskOption -->
        <banner
            ref="banner"
            :type="type"
            :mobileType="mobileType"
            :useMobileSettings="useMobileSettings"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :mobilePicture="mobilePicture"
            :pictureListOption="pictureListOption"
            :mobilePictureListOption="mobilePictureListOption"
            :maskOption="maskOption"
            :videoOption="videoOption"
            :mobileVideoOption="mobileVideoOption"
            :rawDot="true"
            :getBannerStyle="getBannerStyle"
            :emptyBgColor="'rgba(218, 218, 218, 0.2)'"
        />
        <media-content
            :class="`media-content-search-group ${
                titleAlign ? 'align-' + titleAlign : ''
            }`"
            :type="contentType"
            :title="title"
            :subTitle="subTitle"
            :titleAlign="titleAlign"
            :subTitleMbSize="20"
            :showShadow="showShadow"
            :layout="searchBarLayout"
            class="row2column"
            v-animated="{name: 'appear-down', enable: showAnimationEffects}"
        >
            <template #info>
                <div
                    v-if="useType === 'video'"
                    class="play-video"
                    @click="doVideoPlay"
                ></div>
            </template>
            <div v-if="useType === 'video'" class="video-loading"></div>
            <div class="media-content-box" @click="avoidEmitMedia">
                <search-group
                    :needSearchCondition="false"
                    :searchGroupTabs="searchGroupTabList"
                    :searchGroupConfig="searchGroupConfig"
                    :nameType="nameType"
                    :nameRequired="nameRequired"
                    :phoneRequired="phoneRequired"
                    :agreementData="agreementData"
                />
            </div>
        </media-content>
    </div>
</template>

<script>
import common from '../index.js';
import MediaContent from '../../../components/media-content-v2.vue';
import SearchGroup from './search-group.vue';
export default {
    data: function() {
        return {
            backgroundColor: ''
        };
    },
    mixins: [common],
    components: {
        MediaContent,
        SearchGroup
    },
    computed: {
        mobileHeight() {
            return window.innerHeight + 'px';
        }
    },
    methods: {
        getBannerStyle({ autoHeight, type, isMobileSize, BANNER_TYPE }) {
            if (type == BANNER_TYPE.fullScreen && isMobileSize) {
                return {
                    minHeight: Math.max(300, autoHeight) 
                }
            }
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-hero.layout10 {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    .banner {
        width: 50%;

        .banner-video video {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .media-content-v2 {
        position: absolute;
        left: 0;
        width: auto;
        padding-right: 50px;
        padding-left: 50px;
        align-items: flex-start;
        max-width: none;
        pointer-events: none;
        .media-info {
            pointer-events: auto;
            width: 100%;
        }
        .title-text {
            padding: 0 !important;
        }
        .title-text .site-title {
            
            color: var(--g-primary-color);
        }
        .title-text .site-subtitle {
            margin-top: 30px;
            
            color: var(--g-text-color);
        }
        &.align-left {
            .title-text .site-title,
            .title-text .site-subtitle {
                text-align: left;
            }
        }
        &.align-center {
            .title-text .site-title,
            .title-text .site-subtitle {
                text-align: center;
            }
        }
        &.align-right {
            .title-text .site-title,
            .title-text .site-subtitle {
                text-align: right;
            }
        }
    }
    .media-content-box {
        width: 1000px;
        max-width: 100%;
        margin-top: 90px;
        pointer-events: none;
        .tab-header-ul,
        .tab-body,
        .search-by-section,
        .condition-search {
            pointer-events: auto;
        }
    }
    .media-content-none {
        .media-content-box {
            margin-top: 0;
            .title-text {
                padding-bottom: 0 !important;
            }
        }
    }
}
.md-hero.layout10.mobile {
    flex-direction: column;
    .banner {
        width: 100%;
        display: block;
        padding: 0;

        .banner-video {
            width: 100%;
            height: 100%;
            &.play-inline .video-box {
                display: block !important;
            }
            &:not(.play-inline) {
                min-height: 300px;
            }
        }
    }

    .media-content-v2 {
        position: relative;
        padding-right: 15px;
        padding-left: 15px;
        width: 100%;
        .media-info {
            width: 100%;
            padding-right: 0;
            margin-bottom: 0;
        }
        .title-text {
            padding: 21px 0 !important;
        }

        .title-text .site-subtitle {
            margin-top: 15px;
        }
    }
    .media-content-box {
        width: 100%;
        margin-top: 0;
    }

    .media-content-none {
        .title-text {
            padding-bottom: 0 !important;
        }
    }
    .banner-video video {
        min-height: 300px;
        object-fit: cover;
    }
}
</style>
